import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchTeamGroup = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, clubId } = useParams();

  return useQuery({
    queryKey: ["teamGroups", sport, organizationId, clubId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/entityGroups/${clubId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!clubId,
  });
};

export const useFetchTeamGroups = (params = {}, enabled) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/entityGroups`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["teamGroups", sport, organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
    enabled: !!enabled,
  });
};
